import { render, staticRenderFns } from "./addCrmCustomer.vue?vue&type=template&id=03e84e3a"
import script from "./addCrmCustomer.vue?vue&type=script&lang=js"
export * from "./addCrmCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports